import React from 'react';
import { CardView, CardViewProps } from './Card.view';

const Card = ({
  title,
  subTitle,
  desc,
  labels,
  footerTitle,
  btns,
  links,
  onClick
}: CardViewProps) => {
  return (
    <CardView
      title={title}
      labels={labels}
      desc={desc}
      subTitle={subTitle}
      footerTitle={footerTitle}
      btns={btns}
      links={links}
      onClick={onClick}
    />
  );
};

export default Card;
